import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getCurrentUser } from '@/api/login'

/** 拥有此菜单权限时才显示 Homepage（Dashboard）入口 */
const MENU_HOME_PAGE = 'NSP IN PROGRESS'
const MENU_DOOR_SUMMARY = 'doManagementDoorSummary'

export const useUserStore = defineStore('user', () => {
  const showHomePage = ref(false)
  const showDoorSummary = ref(false)
  const roleGroupList = ref<string[]>([])
  const loaded = ref(false)

  async function loadUser(force = false) {
    if (loaded.value && !force) return
    try {
      const res = await getCurrentUser()
      const list = (res as any)?.data?.menus
      const arr = Array.isArray(list) ? list : []
      showHomePage.value = arr.includes(MENU_HOME_PAGE)
      showDoorSummary.value = arr.includes(MENU_DOOR_SUMMARY)
      const rg = (res as any)?.data?.roleGroupList
      roleGroupList.value = Array.isArray(rg) ? rg : []
    } catch {
      showHomePage.value = false
      showDoorSummary.value = false
      roleGroupList.value = []
    } finally {
      loaded.value = true
    }
  }

  return { showHomePage, showDoorSummary, roleGroupList, loaded, loadUser }
})
